// extracted by mini-css-extract-plugin
export default {"md":"markdown-module___md___bcc8310b","more":"markdown-module___more___e82dfcb0"};